import { render, staticRenderFns } from "./CompetitionViewQuestionsList.vue?vue&type=template&id=bebf8752&"
import script from "./CompetitionViewQuestionsList.vue?vue&type=script&lang=js&"
export * from "./CompetitionViewQuestionsList.vue?vue&type=script&lang=js&"
import style0 from "./CompetitionViewQuestionsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports